<script setup>
// Composables
import { skipToContent } from '@/composables/ada/skipToContent';
</script>

<template>
    <div class="meta-actions">
        <a @click.prevent="skipToContent" href="#main" class="skip-link sr-only sr-only-focusable" aria-label="Skip to content">Skip to Content</a>
    </div>
</template>

<style lang="scss">
.meta-actions {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
}
</style>
